import React from "react"

const AppsNavigation = () => <ul className="gx-app-nav"></ul>

export default AppsNavigation
